import { useState, useEffect } from 'react'
import { StationContextInterface } from '../../StationContext'
import useLiveViewScreenshot from '../../../LiveView/hooks/useLiveViewScreenshot'

export const useLiveViewHandler = (stationContext: StationContextInterface) => {
    const [loading, setLoading] = useState(false)
    const [liveViewScreenshot, setLiveViewScreenshot] = useState<string | undefined>()
    const [selectedImageSource, setSelectedImageSource] = useState(0)
    const { getScreenshot } = useLiveViewScreenshot()

    const loadLiveViewScreenshotHandler = async () => {
        setLoading(true)
        const stationUUIDAtLoad = stationContext.deviceData?.uuid
        const liveViewURL = await getScreenshot()

        //here it will check whether the station has changed or not
        if (stationUUIDAtLoad === stationContext.deviceData?.uuid) {
            setLiveViewScreenshot(liveViewURL)
        }
        setLoading(false)
    }

    const removeLiveViewUrl = () => {
        setLiveViewScreenshot(undefined)
        setLoading(false)
    }

    useEffect(() => {
        setLiveViewScreenshot(undefined)
        setSelectedImageSource(0)
    }, [stationContext.selectedStationData])

    return {
        loading,
        liveViewScreenshot,
        selectedImageSource,
        setSelectedImageSource,
        loadLiveViewScreenshotHandler,
        removeLiveViewUrl
    }
}
